import React from 'react'
import ProductCard from '../ProductCard2';
import { useSelector } from 'react-redux';

const GridCard = ({ item,onClick }) => {
    const productList = useSelector((state) => state.productList);
    const { loading, error, products } = productList;
    return (
        <div className="w-full  mx-auto p-2 lg:p-6 xl:p-6  bg-[--color-button-1]">
            <h4 className="text-center font-semibold mb-6">{item.colection.title}</h4>
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4 ">
                {products&&  products.slice(0, 6)?.map((p) => (
                    <ProductCard key={p.id} product={p}   onClick={onClick} />
                ))}
            </div>
        </div>
    )
}
export default GridCard;